<template>
    <div v-if="initDataLoaded">
        <v-layout row wrap>
            <v-flex xs12 md3 pr-2>
                <v-text-field 
                    v-model="searchParams.catalogNum" 
                    label="Catalog #"
                    hint="Partial or full number"
                    ></v-text-field>
            </v-flex>
            <!-- <v-flex xs12 md3 pr-2>
                <v-text-field 
                    v-model="searchParams.number" 
                    label="Item Number"
                    hint="Partial or full number"
                    ></v-text-field>
            </v-flex> -->
            <v-flex xs12 md3 pr-2>
                <v-text-field 
                    v-model="searchParams.description" 
                    label="Item Name"
                    hint="Partial or full name"
                    ></v-text-field>
            </v-flex>
            <v-flex xs12 md2>
                <v-select
                    v-model="searchParams.prodDbTypeId"
                    label="Category"
                    :items="itemGroups"
                    item-text="name"
                    item-value="id"
                ></v-select>
            </v-flex>
            <v-flex xs12 md3 text-xs-center>
                <v-btn color="primary" @click.prevent="searchQuotes">Submit</v-btn>
            </v-flex>
        </v-layout>
        <!-- {{getUserDefaultQuoteSearchCriteria()}}
        {{userItemAdvancedSearchParams}} -->
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    props: ['defaultRows', 'allowSearchNoParas'],
    data () {
        return {
            // allLookups: null,
            itemGroups: [
                {id: 'common', name: 'Common'},
                {id: 'endo', name: 'Endo'}
            ],
            searchParams: null,
            foundSearchParamsInState: false, //why need this? if searchParams loaded from state, we will not change page to 1
        }
    },
    computed: {
        ...mapGetters('auth', [
            'userHasPublicRole',
        ]),
        ...mapGetters('itemSearch', [
            'userItemAdvancedSearchParams'
        ]),
        initDataLoaded () {
            return true     //this.allLookups && this.searchParams
        },
    },
    methods: {
        // ...mapActions('pubQuoteSearch', [
        //     'getUserDefaultQuoteSearchCriteria',
        //     'getUserDefaultQuoteSearchLookups',
        // ]),
        searchQuotes () {
            if(this.searchParams) {
                if(!this.allowSearchNoParas 
                    && !this.searchParams.number 
                    && !this.searchParams.catalogNum 
                    && !this.searchParams.description) {
                    alert('No Search Criteria Found!')
                    return
                }
                // console.log('kkkkl')
                if(!this.foundSearchParamsInState) {
                    this.searchParams.page = 1
                } else {
                    this.foundSearchParamsInState = false
                }
                this.$emit('onSearchParamsChanged', this.searchParams)

            }
        }
    },
    watch: {
        // searchParams: {
        //     handler: function (newVal, oldVal) {
        //         this.searchQuotes()
        //     },
        //     deep: true
        // },
    },
    async created () {
        const defaultParas = {
            page: 1,
            recordsPerPage: 10,
            prodDbTypeId: 'common',
            statusId: 'active',
            classId: 'All'
        }
        this.searchParams = this.userItemAdvancedSearchParams || defaultParas

    },

}
</script>
